import { TrainingDocument } from "./TrainingDocument";

export class PostGraduateYear {
    constructor(physicianId: number) {
        this.inEditMode = true;
        this.physicianId = physicianId;
    }
    sequenceNumber: number;
    trainingProgramCode: string;
    trainingProgramName1: string;
    startDate: string;
    endDate: string;
    totalAttestedMonths: number;
    months: number;
    source: string;
    isAttestedComplete: boolean;
    isAccepted: boolean;
    trainingId: number;
    trainingProgramId: number;
    ownedByTrainingProgramTypeId: number;
    inEditMode: boolean;
    physicianId: number;
    viewDocuments?: boolean;
    ownedByTrainingProgramId: number;
    showOtherProgram: boolean;
    trainingDocuments: Array<TrainingDocument>;
    documentReviewStatus: DocumentReviewStatus;
}

export enum DocumentReviewStatus {
    NoDocuments = 1,
    Hold = 2,
    Approved = 3,
    Denied = 4,
    HoldWithChanges = 5,
    ToBeReviewed = 6
}